<!-- <div class="row">
    <div class="col-10">
        <nav class="navbar navbar-expand-lg ">
            <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
        </nav>
    </div>

    <span class = "helplogout">
        <div class="col-2">
          <a class="getHelp">NeedHelp</a>
      </div>
      </span>
       <span class = "helplogout">
        <div class="col-2">
          <a class="logout" routerLink="/logout" routerLinkActive="active">Logout</a>
        </div>
       </span>
</div> -->
<app-header></app-header>
<div class="container-fluid bg-light px-lg-5">
  <nav class="navbar navbar-expand-lg navbar-light">
    <!-- <a class="navbar-brand" href="#"></a> -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link paddingFromApp" routerLink="/registration">
            App Registration <span class="sr-only">(current)</span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/app-mgmt">App Management</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/profile-mgmt">Profile Management</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/resources">Resources</a>
        </li>
      </ul>
    </div>
  </nav>
</div>
<div class="container-fluid">

  <br>
  <br>

  <p class="mandatorynote"> Fields with * symbol are mandatory one.</p>

  <p *ngIf="isLoading" class="loading"><i class="fa fa-spinner"></i>...Loading</p>

  <p *ngIf="editwaiting" class="msgcolor">Please wait for Editing..</p>

  <p *ngIf="editSuccesfullMsg" class="msgcolor">Your Profile is Succesfully Edited.</p>

  <div *ngIf="deleteSuccess" class="success">
    <p>Your Profile has been deleted Succesfully.</p>
    <a class="btn btn-success" routerLink="/landing">Go To Home Page</a>
  </div>
  <div *ngIf="deleteFail" class="msgcolor">
    <p>There is an issue while deleting your Profile.</p>
  </div>

  <div *ngIf="isEditProfileGet" class="row justify-content-center">
    <div class="col-md-8">
      <div class="card">
        <div class="card-header">Profile Management</div>
        <div class="card-body">
          <form class="form-horizontal">

            <!-- heading section left side on page -->

            <div class="row">

              <!-- <div class="col-lg-6">
                  <h1>Manage your Profile.</h1>
                  <h3>Edit your Profile as Developer and get started.</h3>
              </div> -->
              <!-- Form section -->

              <div class="col-lg-12">

                <form #f1="ngForm">
                  <!-- <p *ngIf="editwaiting" class="msgcolor">Please wait for Editing..</p>

                  <p *ngIf="editSuccesfullMsg" class="msgcolor">Your Profile is Succesfully Edited.</p>

                  <div *ngIf="deleteSuccess" class="success">
                      <p>Your Profile has been deleted Succesfully.</p>
                      <a class="btn btn-success" routerLink="/landing">Go To Home Page</a>
                      </div>
                      <div *ngIf="deleteFail" class="msgcolor">
                          <p>There is an issue while deleting your Profile.</p>
                         </div> -->
                  <!-- <button type="submit" [disabled]="!f1.valid" class="btn btn-primary right-space" style="
                  margin-right: 20px;" (click)="callPostProfileMgmtEditService()">
                                          Edit</button>
                                      <button type="submit" class="btn btn-primary" style="
                  margin-right: 20px;" (click)="onDeleteProfile()">
                                          Delete</button>
                                      <button type="submit" class="btn btn-primary" (click)="onResetPassword()"> Reset
                                          Password</button> -->

                  <div class="form-row">

                    <div class="form-group col-lg-6">
                      <label for="firstName">First Name</label>
                      <input [(ngModel)]="FirstName" type="text" class="form-control" id="firstName"
                             placeholder="" name="firstName" readonly>
                    </div>

                    <div class="form-group col-lg-6">
                      <label for="lastName">Last Name</label>
                      <input [(ngModel)]="LastName" type="text" class="form-control" placeholder=""
                             name="LastName" readonly>
                    </div>
                  </div>

                  <div class="form-row">

                    <div class="form-group col-md-6">
                      <label for="address " class="required">Street Address</label>
                      <input [(ngModel)]="EditStreetAddress" #address="ngModel" type="text"
                             class="form-control" id="address" placeholder="" name="streetAddress" required>
                    </div>

                    <div class="form-group col-md-6">
                      <label for="inputCity" class="required">City</label>
                      <input [(ngModel)]="Editcity" #city="ngModel" type="text" class="form-control"
                             placeholder="" name="city" required>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Country">Country</label>
                      <select class="form-control" [(ngModel)]="EditCountry" name="Country">
                        <option>{{EditCountry}}</option>
                        <option *ngFor="let item of loadedCountry">
                          {{item.country_Name}}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="State" class="required">State</label>
                      <input [(ngModel)]="EditState" type="text" class="form-control" id="state"
                             placeholder="" name="state" required>
                      <!-- <input type="text" class="form-control" [(ngModel)]="EditState" name="State" /> -->
                      <!-- <select class="form-control" [(ngModel)]="EditState" name="State" required>

                          <option>{{EditState}}</option>
                          <option *ngFor="let items of loadedState" [value]="items.id">
                              {{items.state_Name}}
                          </option>
                      </select> -->
                      <!-- <input type="text" class="form-control" id="Street" placeholder="test"> -->
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col">
                      <label for="" class="required"> ZipCode</label>
                      <input [(ngModel)]="EditZipCode" #city="ngModel" type="text"
                             class="form-control" id="zipCode" placeholder="" name="zipcode" required>
                    </div>

                    <div class="form-group col">
                      <label for="Phone" class="required">Phone Number</label>
                      <input [(ngModel)]="EditPhone" #city="ngModel" type="text" class="form-control"
                             id="Phone" placeholder="" name="phone"
                                    pattern="^[(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4}$" #phone1=ngModel required />
                        <p *ngIf="!phone1.valid" class="msgred">
                         Phone Number must contain 10 digits and must be in
                         format of 123-456-7890.
                        <p>
                             
                    </div>
                  </div>

                  <div class="form-row">

                    <div class="form-group col">
                      <label for="OrganizationName" class="required">OrganizationName</label>
                      <input type="text" class="form-control" placeholder="" [(ngModel)]="EditOrgName"
                             name="OrganizationName" required />
                    </div>

                    <div class="form-group col">
                      <label for="OrganizationTaxID" class="required">OrganizationTaxID</label>
                      <input type="text" class="form-control" placeholder=""
                             [(ngModel)]="EditOrgTaxID" name="OrganizationTaxID" required />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="OrgStreetAddress">Organization StreetAddress</label>
                      <input [(ngModel)]="EditOrgStreet" type="text" class="form-control"
                             placeholder="" name="OrgStreetAddress" />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="OrgCity">Organization City</label>
                      <input [(ngModel)]="EditOrgCity" type="text" class="form-control" placeholder=""
                             name="OrgCity" />
                    </div>
                  </div>

                  <div class="form-row">

                    <div class="form-group col-md-6">
                      <label for="Organization Country">Organization Country</label>
                      <select class="form-control" [(ngModel)]="EditOrgCountry" name="OrgCountry">
                        <option>{{EditOrgCountry}}</option>
                        <option *ngFor="let item of loadedCountry">
                          {{item.country_Name}}
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-md-6">
                      <label for="Organization State">Organization State</label>
                      <input [(ngModel)]="EditOrgState" type="text" class="form-control" id="OrgState"
                             placeholder="" name="OrgState">
                      <!-- <select class="form-control" [(ngModel)]="EditOrgState" name="OrgState" required>
                          <option selected>{{EditOrgState}}</option>

                          <option *ngFor="let items of loadedState" [value]="items.id">
                              {{items.state_Name}}
                          </option>
                      </select> -->
                    </div>
                  </div>
                  <div class="row">

                    <div class="form-group col-md-6">
                      <label for="">Organization ZipCode</label>
                      <input [(ngModel)]="EditOrgZipCode" type="text" class="form-control"
                             id="zipCode" placeholder="" name="orgZipCode">
                    </div>
                    <div class="form-group col-md-6">
                      <label for="">Organization Phone Number</label>
                      <input [(ngModel)]="OrgPhoneNumber" type="text" class="form-control"
                             id="OrgPhoneNumber" placeholder="" name="OrgPhoneNumber"

                             pattern="^[(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4}$" #phone=ngModel />

                      <p *ngIf="!phone.valid" class="msgred">
                        Phone Number must contain 10 digits and must be in
                        format of 123-456-7890.
                      </p>
                    </div>
                  </div>

                  <div class="row">

                    <div class="form-group col-md-6">
                      <label for="">Organization AltEmail</label>
                      <input [(ngModel)]="OrgAltEmail" type="text" class="form-control"
                             id="OrgAltEmail" placeholder="" name="OrgAltEmail"
                             pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
                             #altemail=ngModel />
                      <span *ngIf="!altemail.valid" class="msgred">
                        Ensure your Email Address is in valid
                        format.
                      </span>
                    </div>
                    <!-- <div class="form-group col-md-6">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="gridCheck" name="carin"
                                [(ngModel)]="Carin_Bio_Url" />
                            <label class="form-check-label" for="gridCheck">
                                Application’s CARIN Bio URL
                            </label>
                        </div>
                    </div> -->
                  </div>
                  <button type="submit" [disabled]="!f1.valid" class="btn btn-primary right-space" style="
                                margin-right: 20px;" (click)="callPostProfileMgmtEditService()">
                    Submit
                  </button>
                  <button type="submit" class="btn btn-primary deletesubmit" style="
                                margin-right: 20px;"
                          mwlConfirmationPopover
                          [popoverTitle]="popoverTitle"
                          [popoverMessage]="popoverMessage"
                          placement="left"
                          (confirm)="onDeleteProfile()"
                          (cancel)="cancelClicked = true">
                    Delete
                  </button>
                  <button type="submit" class="btn btn-primary deletesubmit" (click)="onResetPassword()">
                    Reset
                    Password
                  </button>
                </form>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isEditProfileGet">
  <app-footer></app-footer>
</div>

<!-- </div>
</div>
</form> -->
